// extracted by mini-css-extract-plugin
export default {"genericCard":"To-z","inline":"Uo-z","mastercard":"Vo-z","discover":"Wo-z","visa":"Xo-z","amex":"Yo-z","active":"Zo-z"};